export default __webpack_public_path__ + "static/media/users.fea1f969.svg";